import { bicond } from '../../../utilities/shared/logicalOperators/logicalBiconditional';

export type TDateSelectionMode = 'Selected Date' | 'Before Date' | 'After Date';
const modeSet = new Set<unknown>(['Selected Date', 'Before Date', 'After Date']);
export const isDateSelectionMode = (val: unknown): val is TDateSelectionMode => modeSet.has(val);

// a Date Range of '2025-01-01' and '2025-01-01' is a single date.
// we want to know if it is a "true" range of multiple dates (e.g. '2025-01-01' and '2025-01-08' or '2025-01-01' and '2025-02-02')
export const isRangeOfMultipleDates = (startFieldValue: string, endFieldValue: string): boolean => {
  if (!startFieldValue) {
    return false;
  }
  if (!endFieldValue) {
    return false;
  }

  return startFieldValue !== endFieldValue;
};

export const determineModeFromInitialValues = (startFieldValue: string, endFieldValue: string): TDateSelectionMode => {
  if (bicond(!!startFieldValue, !!endFieldValue)) {
    return 'Selected Date';
  }
  if (!startFieldValue) {
    return 'Before Date';
  }
  return 'After Date';
};
